import React, { useState, useEffect } from 'react';
import { Button, Spin, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import * as orderService from '../../../../services/order/orderService';
import OrderDetailContent from '../components/OrderDetailContent';

/**
 * 订单详情独立路由页
 * 路由: /order/order/:orderNo
 * 主要由 substitute-management 等页面 navigate 跳转进来
 */
const OrderDetail = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { orderNo } = useParams();
  const [loading, setLoading] = useState(false);
  const [orderDetail, setOrderDetail] = useState(null);

  // 获取订单详情
  const fetchOrderDetail = async () => {
    if (!orderNo) return;

    setLoading(true);
    try {
      const response = await orderService.getOrderByOrderNo(orderNo);

      if (response.success) {
        setOrderDetail(response.data);
      } else {
        message.error(response.errorMessage || t('common.message.operationFailed'));
      }
    } catch (error) {
      console.error('查询订单详情失败:', error);
      message.error(t('common.message.operationFailed'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrderDetail();
  }, [orderNo]);

  return (
    <div>
      {/* 页面标题和返回按钮 */}
      <div
        style={{
          marginBottom: '24px',
          padding: '16px 0',
          borderBottom: '1px solid #f0f0f0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <h2
          style={{
            margin: 0,
            fontSize: '20px',
            fontWeight: '600',
            color: '#1d1d1d',
          }}
        >
          {t('order.order.detail.title')} - {orderNo}
        </h2>
        <Button onClick={() => navigate(-1)}>{t('common.actions.back')}</Button>
      </div>

      <Spin spinning={loading}>
        {orderDetail && <OrderDetailContent orderDetail={orderDetail} />}
      </Spin>
    </div>
  );
};

export default OrderDetail;
